// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"vsscqN","header":"mbyRhc","content":"rQCEsu","expanded":"mJSX9J","titleContainer":"CzUYWl","title":"BoP7YN"};